module.exports = __webpack_public_path__ + "media/images/river/Badge-e5eebfdb30bacb441ff162863622a563.svg";